
const locales = {
    fr: {
        contact_success: 'Votre message a bien été envoyé. Nous vous apporterons une réponse dans les plus brefs délais.',
        contact_captcha: 'Veuillez remplir le captcha.',
        contact_error: 'Une erreur est intervenue, veuillez réessayer.'
    }
}

export const translate = (key, params, locale) => {
    let str = locales[locale][key];

    if(typeof params === "object" && params !== null) {
        Object.keys(params).forEach(key => str = str.split(`:${key}`).join(params[key]));
    }

    return str;
}

window.translate = translate;

export default locales;
